import { z } from 'zod';
import {
  firstNameValidationSchema,
  lastNameValidationSchema,
} from '@/schemas/ValidationSchema.ts';

export const acceptInvitationSchema = z.object({
  firstName: firstNameValidationSchema,
  lastName: lastNameValidationSchema,
});

export type AcceptInvitationFormData = z.infer<typeof acceptInvitationSchema>;
